import { createApi } from "@/api";

export const api = createApi({});

if (CONFIG.basePath) {
  api.setBaseUrl(`/${CONFIG.basePath}`);
}
